import { useDataTableParamState } from "@/common/hooks/useDataTableParamState";
import {
  useSearchArrayParam,
  useSearchParam,
} from "@/common/hooks/useSearchParam";
import { getDefaultColumnStates } from "@/common/utils/datatable";
import { FunnelStep, FunnelStepList } from "@reflag/shared/featureAPI";
import {
  FeedbackListColumn,
  FeedbackListSortBy,
} from "@reflag/shared/feedbackAPI";
import { SatisfactionSpan } from "@reflag/shared/schemas/satisfactionScore";

const defaultFunnelSteps = [...FunnelStepList];

export const defaultFeedbackColumns: FeedbackListColumn[] = [
  "score",
  "comment",
  "featureName",
  "userName",
  "companyName",
  "companyFunnelStep",
  "timestamp",
  "actions",
];

export const useFeedbackTableState = () => {
  // Filters
  const [satisfactionFilter, onSatisfactionFilterChange] =
    useSearchParam<SatisfactionSpan>("satisfaction");
  const [featureFilter, onFeatureFilterChange] = useSearchParam("feature");
  const [companyFilter, onCompanyFilterChange] = useSearchParam("company");
  const [funnelStepsFilter, onFunnelStepsFilterChange] =
    useSearchArrayParam<FunnelStep>("stars", {
      fallback: defaultFunnelSteps,
    });
  const [segmentFilter, onSegmentFilterChange] = useSearchParam("segment");

  // Create table state from view data and url params.
  const tableState = useDataTableParamState<
    FeedbackListSortBy,
    FeedbackListColumn
  >({
    sorting: [{ id: "timestamp", desc: true }],
    columnStates: getDefaultColumnStates(defaultFeedbackColumns),
  });

  return {
    ...tableState,
    satisfactionFilter,
    onSatisfactionFilterChange,
    featureFilter,
    onFeatureFilterChange,
    companyFilter,
    onCompanyFilterChange,
    funnelStepsFilter,
    onFunnelStepsFilterChange,
    segmentFilter,
    onSegmentFilterChange,
    onReset: () => {
      onSatisfactionFilterChange(undefined);
      onCompanyFilterChange(undefined);
      onFeatureFilterChange(undefined);
      onFunnelStepsFilterChange(defaultFunnelSteps);
      onSegmentFilterChange(undefined);
      tableState.onReset();
    },
  };
};
